import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const MyProfileUserManagementStyled = styled.div`
  .containerHeader {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    max-width: 100%;
    /* Sin padding propio: el de la página (30px 60px) es el mismo que en candidatos y favoritos */
    padding: 0;
    gap: 50px;
  }

  .sectionSecond {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 15px;

    label {
      font-weight: 500;
      font-size: 14px;
      margin-bottom: 0px;
      margin-right: 20px;
    }
    input {
      font-size: 14px;
      font-family: 'Poppins';
    }

    & h2 {
      font-size: 20px; /* título de página de Velora, igual que candidatos y favoritos */
      font-weight: 600;
      line-height: 1.2;
      color: ${tokens.color.text.primary};
      margin-bottom: 0;
    }
    & h5 {
      font-size: 14px;
      font-weight: 400;
      color: ${tokens.color.text.tertiary};
      line-height: inherit;
    }

    & p {
      font-weight: 400;
      color: #7a808d;
    }
  }

  .autocomplete-custom {
    width: 240px;
  }

  .MuiTableHead-root th:first-child {
    text-align: center !important;
  }

  .MuiTableHead-root th:not(:first-child) {
    text-align: left !important;
  }

  .headerTable {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;

    h3 {
      margin-bottom: 0px;
    }
  }

  /* Filtros a la izquierda; acción masiva y toggle Activos / Inactivos a la derecha */
  .users-header {
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;

    .users-filters,
    .users-actions {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 16px;
    }
  }

  .containerButton {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    gap: 20px;
    height: 36px;
  }

  .MuiTableCell-root {
    font-family: 'Poppins';
  }
`

export default MyProfileUserManagementStyled
